import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import Tattoo1 from "./Tattoo1.jpg";
import Luciana1 from "./Luciana.jpg";
import Luciana2 from "./Luciana2.jpg";
import videoCurso from "../../assets/CursoVideo.mp4";

const LegalLucianaTattoo = () => {

  const images = [Luciana1, Tattoo1, Luciana2];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      className="relative min-h-screen flex flex-col items-center p-6
      pt-[calc(var(--navbar-height,4rem)+1rem)] overflow-hidden"
    >

      {/* BACKGROUND MOBILE */}
      <div className="absolute inset-0 md:hidden -z-10 overflow-hidden">
        <motion.img
          key={currentImage}
          src={images[currentImage]}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2 }}
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* VIDEO DESKTOP */}
      <div className="absolute inset-0 w-full h-full overflow-hidden -z-10 hidden md:block">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover"
        >
          <source src={videoCurso} type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* CONTENIDO */}
      <div className="relative z-10 max-w-4xl w-full text-white">

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-[#0f0f0f]/80 backdrop-blur-lg border border-[#d7b48a]/30
          rounded-2xl p-8 md:p-12 shadow-2xl"
        >

          <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-6">
            Aviso Legal
          </h1>

          <h2 className="text-xl text-[#d7b48a] text-center mb-8">
            Luciana Avalos Tattoo
          </h2>

          <div className="space-y-8 text-sm md:text-base leading-relaxed opacity-90">

            <div>
              <p>
                <strong>Sitio web:</strong> lucianaavalostattoo.com
              </p>
              <p>
                <strong>Contacto legal:</strong> lucianavalos2002@gmail.com
              </p>
              <p>
                <strong>Última actualización:</strong> 9 de marzo de 2026
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                1. Información general
              </h3>

              <p>
                El presente documento regula el acceso, navegación y uso del sitio
                web de Luciana Avalos Tattoo (en adelante, “el Sitio”).
              </p>

              <p>
                El acceso al Sitio implica la aceptación plena y sin reservas de
                todas las disposiciones incluidas en este documento.
              </p>

              <p>
                El Sitio puede contener información, contenidos, material
                audiovisual, portafolio de tatuajes, publicaciones, formularios de
                contacto o recursos destinados a facilitar la comunicación con
                usuarios y clientes.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                2. Condición de usuario
              </h3>

              <p>
                Se considera usuario a cualquier persona que acceda, navegue o
                interactúe con el Sitio.
              </p>

              <p>
                El usuario se compromete a utilizar el Sitio conforme a la
                legislación vigente, la buena fe y las disposiciones del presente
                documento.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                3. Uso inadecuado del sitio
              </h3>

              <ul className="list-disc ml-6 space-y-1">
                <li>realizar actividades ilegales</li>
                <li>vulnerar derechos de terceros</li>
                <li>intentar acceder a sistemas sin autorización</li>
                <li>introducir virus o malware</li>
                <li>interferir con el funcionamiento del sitio</li>
                <li>recopilar información sin autorización</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                4. Propiedad intelectual
              </h3>

              <p>
                Todos los contenidos presentes en el Sitio, incluyendo fotografías
                de tatuajes, diseños, imágenes, textos, material audiovisual,
                logotipos y estructura del sitio web, son propiedad de Luciana
                Avalos Tattoo o se utilizan con autorización correspondiente.
              </p>

              <p>
                Queda prohibida su reproducción o distribución sin autorización
                previa.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                5. Contenido visual
              </h3>

              <p>
                Las imágenes, fotografías o material visual publicado en el Sitio
                pueden mostrar trabajos reales realizados por la artista.
              </p>

              <p>
                Los resultados pueden variar dependiendo del tipo de piel,
                cuidados posteriores y otros factores individuales.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                6. Protección de datos personales
              </h3>

              <p>
                El Sitio puede recopilar información personal cuando los usuarios
                completan formularios o envían consultas.
              </p>

              <p>Estos datos pueden incluir:</p>

              <ul className="list-disc ml-6 space-y-1">
                <li>nombre</li>
                <li>correo electrónico</li>
                <li>teléfono</li>
                <li>mensajes enviados</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                7. Finalidad del tratamiento de datos
              </h3>

              <ul className="list-disc ml-6 space-y-1">
                <li>responder consultas</li>
                <li>gestionar solicitudes de turnos</li>
                <li>mejorar la experiencia del sitio</li>
                <li>análisis estadísticos</li>
                <li>optimizar campañas publicitarias</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                8. Política de cookies
              </h3>

              <p>
                El Sitio puede utilizar cookies y tecnologías similares para
                mejorar la experiencia del usuario, analizar el tráfico web y
                medir la efectividad de campañas publicitarias.
              </p>

              <p>
                El usuario puede configurar su navegador para rechazar o eliminar
                cookies en cualquier momento.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                9. Jurisdicción
              </h3>

              <p>
                El presente documento se interpreta conforme a la legislación de
                la República Argentina.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#d7b48a] mb-2">
                10. Modificaciones
              </h3>

              <p>
                Luciana Avalos Tattoo se reserva el derecho de modificar el
                presente documento en cualquier momento. Las modificaciones
                entrarán en vigencia desde su publicación en el Sitio.
              </p>
            </div>

          </div>
        </motion.div>

      </div>

    </section>
  );
};

export default LegalLucianaTattoo;